import { render, staticRenderFns } from "./ImportWizardNavItem.vue?vue&type=template&id=c9937920&scoped=true&"
import script from "./ImportWizardNavItem.vue?vue&type=script&lang=js&"
export * from "./ImportWizardNavItem.vue?vue&type=script&lang=js&"
import style0 from "./ImportWizardNavItem.vue?vue&type=style&index=0&id=c9937920&prod&scoped=true&lang=scss&"
import style1 from "./ImportWizardNavItem.vue?vue&type=style&index=1&id=c9937920&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9937920",
  null
  
)

export default component.exports